import React from 'react'
import { withRouteData, Link } from 'react-static'

import Title from '../../components/Title'
import Transitionable from '../Transitionable'
import Sidebar from '../../components/Sidebar'
import PaginationLinks from '../../components/PaginationLinks'
import BlogPost from '../../components/BlogPost'

import styles from './styles.module.css'

class Blog extends Transitionable {

  robotState = 'blog'

  renderTransitioned() {
    return withRouteData(({ posts, paginator }) => ( 
      <section className={styles.blog}>
          <Title page="Blog" />

          <Sidebar />

            <ul className={styles.postList}>
              { posts.map( post => (
                <li key={post.path}>
                  <BlogPost post={post} />
                </li>
              ))}
            </ul>

             <PaginationLinks paginator={paginator} />
      </section>
    ))()
  }

}

export default Blog



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Blog/index.js